import React from 'react';
import { motion } from 'framer-motion';
import { Search, ShoppingCart, Truck, Star } from '../../lib/lucide-proxy';

const HowItWorks = () => {
  const steps = [
    {
      icon: Search,
      title: 'Encontre sua Cervejaria',
      description: 'Navegue pelas melhores cervejarias artesanais da sua região e descubra novos sabores.',
      color: 'bg-blue-100 text-blue-600'
    },
    {
      icon: ShoppingCart,
      title: 'Monte seu Pedido',
      description: 'Escolha suas cervejas favoritas, adicione ao carrinho e personalize seu pedido.',
      color: 'bg-green-100 text-green-600'
    },
    {
      icon: Truck,
      title: 'Receba em Casa',
      description: 'Acompanhe seu pedido em tempo real e receba suas cervejas geladas em casa.',
      color: 'bg-primary-100 text-primary-600'
    },
    {
      icon: Star,
      title: 'Avalie a Experiência',
      description: 'Compartilhe sua experiência e ajude outros apreciadores a descobrir grandes cervejas.',
      color: 'bg-copper-100 text-copper-600'
    }
  ];

  return (
    <section id="como-funciona" className="py-16 bg-cream-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-display font-bold text-3xl sm:text-4xl text-dark-900 mb-4">
              Como Funciona
            </h2>
            <p className="text-lg text-dark-600 max-w-2xl mx-auto">
              Em poucos passos você pode desfrutar das melhores cervejas artesanais no conforto da sua casa.
              É simples, rápido e seguro.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative"
            >
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-primary-300 to-primary-200 z-0" />
              )}
              <div className="relative bg-white rounded-2xl p-8 shadow-soft hover:shadow-medium transition-all duration-300 transform hover:-translate-y-1 text-center">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-primary-500 text-white rounded-full flex items-center justify-center font-bold text-sm">
                  {index + 1}
                </div>
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-xl mb-6 ${step.color}`}>
                  <step.icon className="w-8 h-8" />
                </div>
                <h3 className="font-semibold text-xl text-dark-900 mb-4 font-display">
                  {step.title}
                </h3>
                <p className="text-dark-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-16 text-center"
        >
          <div className="bg-white rounded-2xl p-8 shadow-soft max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div>
                <div className="text-3xl font-bold text-primary-500 font-display mb-2">
                  30min
                </div>
                <div className="text-dark-600">
                  Tempo médio de entrega
                </div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary-500 font-display mb-2">
                  24/7
                </div>
                <div className="text-dark-600">
                  Suporte ao cliente
                </div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary-500 font-display mb-2">
                  100%
                </div>
                <div className="text-dark-600">
                  Satisfação garantida
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;